export default __webpack_public_path__ + "static/media/rilascio_icona.787cfcf9.svg";